import * as React from 'react';
import './index.css';
import { DynamicTagGroup } from '@/src/components/DynamicTag';
import { highlightListForText } from '@/src/common/Highlight';
import DiscountOutlinedTag from '../DiscountOutlinedTag';
import { ImgBottomLabelMonitor } from './utils/monitor';

interface Props {
  imgBottomLabel: any;
  absoluteStyle?: boolean;
}
export default class ImgBottomLabel extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { imgBottomLabel } = this.props;
    if (!imgBottomLabel) {
      return;
    }
    const {
      labelImgInfo, labelImg, labelDynamicTag, labelText, discountBar, discountDesc, spuPriceLabel,
    } = imgBottomLabel;

    const warpStyle: React.CSSProperties = this.props.absoluteStyle ? {} : { display: 'inline-block', position: 'absolute' };
    switch (true) {
    // 图片腰封
    // labelImgInfo 在 labelImg 的基础上下发了 height 信息，labelImgInfo 优先级更高
      case (labelImgInfo?.imgUrl !== undefined && labelImgInfo?.imgUrl !== null):
      case (labelImg !== undefined && labelImg !== null): {
        let url = '';
        let style: React.CSSProperties = {};
        if (labelImgInfo?.imgUrl) {
          url = labelImgInfo?.imgUrl;
          style = { height: labelImgInfo?.height };
        } else {
          url = labelImg;
        }
        return (
          <view className="favorite-label-wrapper" style={{ ...warpStyle, ...style }}>
            <image
              resizeMode="heightFix"
              className="favorite-label-img"
              src={url}
              style={style}
            />
          </view>
        );
      }
      // 通栏文案腰封
      case (labelText !== undefined && labelText !== null):
        return (
          <view className="bottom-label-full-width-con" style={{ backgroundColor: labelText.bgColor, ...warpStyle }}>
            <text className="bottom-label-full-width-text" style={{ color: labelText.textColor ? labelText.textColor : '#FFFFFF' }} content={labelText.text} />
          </view>
        );
        // 折扣腰封
      case (discountDesc !== undefined && discountDesc !== null):
        return (
          <view className="bottom-label-discount-desc-con">
            <DiscountOutlinedTag text={discountDesc.text} />
          </view>
        );
        // 可配icon的动态标签腰封
      case (labelDynamicTag !== undefined && labelDynamicTag !== null):
        return (
          <view className="bottom-label-dynamic-tag-con" style={warpStyle}>
            <DynamicTagGroup {...imgBottomLabel?.labelDynamicTag} />
          </view>
        );
        // 非通栏带右侧圆角的纯文案腰封
      case (discountBar !== undefined && discountBar !== null):
      {
        const regex = /<highlight>/;
        const hasHighLightText = regex.test(discountBar.text);
        const textColor = discountBar.textColor ? discountBar.textColor : '#FFFFFF';
        return (
          <view
            className="bottom-label-half-width-con" style={{
              height: 28, paddingLeft: hasHighLightText ? 0 : 7, backgroundColor: discountBar.bgColor || '#FFE41F', ...warpStyle
            }}
          >
            {hasHighLightText ? (
              <view className="shop-off-red" style={{ backgroundColor: discountBar.bgColor || '#FFE41F' }}>
                <rich-text
                  content={highlightListForText(discountBar.text).map((item) => ({
                    type: 'text',
                    text: item.text,
                    fontSize: item.highlight ? 14 : 12,
                    color: textColor,
                    fontFamily: 'KeeTa-Bold'
                  }))}
                />
              </view>
            )
              : <text className="bottom-label-full-width-text" style={{ color: textColor }} content={discountBar.text} />}
          </view>
        );
      }
      // 异形腰封特制样式
      // 设计稿链接：https://ingee.meituan.com/#/artboard/1199668/default
      case (spuPriceLabel !== undefined && spuPriceLabel !== null):
      {
        const {
          bgImg: beltImg,
          width: beltWidth,
          height: beltHeight,
          priceArea,
          discountArea
        } = spuPriceLabel;
        const {
          textColor: priceTextColor,
          finalPrice,
          originPrice
        } = priceArea;
        const {
          text: discountText,
          bgColor: discountBgColor,
          textColor: discountTextColor,
        } = discountArea;
        // 到手价富文本，仅LTR顺序可使用
        const contents: any[] = [];
        if (finalPrice?.currencySign) {
          contents.push({
            type: 'text',
            text: finalPrice?.currencySign,
            color: priceTextColor,
            fontFamily: 'KeeTa-Bold',
            fontSize: 14,
            fontWeight: 700
          });
        }
        if (finalPrice?.displayText) {
          contents.push({
            type: 'text',
            text: finalPrice?.displayText,
            color: priceTextColor,
            fontFamily: 'KeeTa-Bold',
            fontSize: 20,
            fontWeight: 700
          });
        }

        const isValid = Boolean(priceArea?.finalPrice?.currencySign
          && priceArea?.finalPrice?.displayText
          && discountText);
        const imgBottomLabelMonitor = new ImgBottomLabelMonitor();
        imgBottomLabelMonitor?.reportSpuPriceLabelData(isValid ? 1 : 0, {
          resultType: isValid ? 'data-valid' : 'data-invalid'
        });

        return (
          <view className="alien-bottom-label-full-width-con" style={{ ...warpStyle, height: beltHeight }}>
            {/* 腰封背景图 */}
            <image
              resizeMode="scaleToFill"
              className="alien-bg-img"
              src={beltImg}
              style={{ width: beltWidth, height: beltHeight }}
            />
            {/* 左侧价格区域 */}
            <view className="alien-bottom-label-left" style={{ ...warpStyle, width: '58%', height: beltHeight }}>
              <view className="alien-bottom-label-left-origin-price" style={{ top: Mach.env.isIOS ? 3 : 2 }}>
                <text
                  className="alien-bottom-label-left-origin-price-text"
                  style={{ color: priceTextColor }}
                  content={originPrice?.displayText}
                />
              </view>
              <view className="alien-bottom-label-left-final-price" style={{ bottom: Mach.env.isAndroid ? 3 : 1 }}>
                {finalPrice?.currencySign && finalPrice?.displayText && <rich-text content={contents} />}
              </view>
            </view>
            {/* 中部间隔 */}
            <view className="alien-bottom-label-middle" style={{ ...warpStyle, width: '3%', height: beltHeight }} />
            {/* 右侧折扣区域 */}
            <view className="alien-bottom-label-right" style={{ ...warpStyle, width: '39%' }}>
              <view className="alien-bottom-label-right-discount">
                <text
                  className="alien-bottom-label-right-discount-text"
                  style={{ color: discountTextColor, backgroundColor: discountBgColor }}
                  content={discountText}
                />
              </view>
            </view>
          </view>
        );
      }
      default:
        return null;
    }
  }
}
